<div class="file-input-wrapper" *ngIf="image$ | async as image">
	<input type="file" accept="image/*" capture="camera" (change)="onFileSelected($event)" class="file-input" />
	<ng-container *ngIf="image.preview; else imageUploadBlock">
		<div class="image-preview">
			<img [src]="image.preview" alt="תצוגת תמונה" />
		</div>
	</ng-container>
	<ng-template #imageUploadBlock>
		<div class="file-input-mask" *ngIf="status$ | async as status" [ngClass]="[status]">
			<span [ngSwitch]="status" class="text-align-center">
				<ng-container *ngSwitchCase="'error'"> יש לנסות שנית </ng-container>
				<ng-container *ngSwitchCase="'idle'"> בחר תמונה </ng-container>
				<ng-container *ngSwitchCase="'uploading'"> מעלה... </ng-container>
			</span>
		</div>
	</ng-template>
</div>
